import { useLanguage } from '@/components/i18n/LanguageProvider'

type DefaultCurrency = { code?: string; symbol?: string | null; name?: string | null }

export function useDefaultCurrency() {
  const { currencyCode, currencySymbol } = useLanguage()
  return { currency: { code: currencyCode, symbol: currencySymbol }, loading: false, error: null }
}

export function formatCurrency(amount: number, currency?: DefaultCurrency, locale?: string) {
  const code = currency?.code || 'EUR'
  const resolvedLocale =
    locale ||
    (typeof window !== 'undefined'
      ? localStorage.getItem('syris_lang') === 'en'
        ? 'en-US'
        : 'fr-FR'
      : 'fr-FR')
  try {
    return new Intl.NumberFormat(resolvedLocale, { style: 'currency', currency: code, minimumFractionDigits: 2 }).format(amount)
  } catch {
    const symbol = currency?.symbol || (code === 'EUR' ? '€' : '')
    if (symbol) return `${amount.toLocaleString(resolvedLocale, { minimumFractionDigits: 2 })} ${symbol}`
    return `${amount.toLocaleString(resolvedLocale, { minimumFractionDigits: 2 })} ${code}`.trim()
  }
}
